<template>
  <span class="body-2 text-static-brand-mid caption-bold">
    {{ i18n(translations.subsidy, { amount: i18n.price(mobilePlan.subsidy) }) }}
  </span>
</template>

<script lang="ts" setup>
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import type { ReadonlyObjectDeep } from 'type-fest/source/readonly-deep'

import translations from './MobilePlanSubsidy.translations'

defineProps<{
  mobilePlan: ReadonlyObjectDeep<MobilePlanOffer>
}>()

const i18n = useI18n()
</script>
